<template>
  <div>
    <v-list v-for="item in items" :key="item.id" class="purchased">
      <v-list-item v-if="isPast(item.pivot.created_at) && item.category != 'merch'" :class="item.pivot.paymentStatus">

        <v-list-item-content>
          <span class="credit">
            <span v-if="item.category == 'pckg'">{{ item.code }}</span>
            <span v-else>{{ item.pivot.notes }}</span>
            <span class="green--text">-${{ item.pivot.price }}</span>
            <br />
            <small>{{ new Date(item.pivot.created_at).toLocaleString("en-AU", {
              timeZone: "UTC", weekday: 'short', year:
                'numeric', month: 'short', day: 'numeric'
            }) }}</small>
          </span>

        </v-list-item-content>

      </v-list-item>


      <v-list-item v-else-if="!isPast(item.pivot.created_at)" :class="item.pivot.paymentStatus">
        <v-list-item-content v-if="item.category === 'merch'">
          <span>{{ item.pivot.notes }} {{ item.m_l }} {{ item.colour }} {{ item.size }}</span> &nbsp; <strong>
            ${{ item.price }}</strong>
        </v-list-item-content>

        <v-list-item-content v-else-if="item.category === 'tips'">
          <span>{{ item.name }} {{ item.pivot.notes }}</span> &nbsp; <strong> ${{ item.pivot.price }}</strong>
        </v-list-item-content>


        <v-list-item-content v-else-if="item.category === 'split'">
          <span>{{ item.pivot.notes }}</span> &nbsp; <strong> ${{ item.price }}</strong>
        </v-list-item-content>


        <v-list-item-content v-else>
          <span>{{ item.pivot.notes }}</span> &nbsp; <strong> ${{ item.pivot.price }}</strong>
        </v-list-item-content>


        <v-list-item-avatar v-if="item.pivot.paymentStatus === 'paid'">
          <v-avatar tile v-if="checkGate('void-transaction')">

            <v-btn class="red--text" @click="voidItem(item)" v-if="item.category != 'split' && item.category != 'pckg'"
              icon>
              <v-icon v-if="item.pivot.paymentMethod == 'CC'">mdi-credit-card-refund</v-icon>
              <v-icon v-else>mdi-cash-refund</v-icon>
            </v-btn>

            <v-btn class="red--text" @click="refund(item)" v-if="item.category == 'pckg'" icon>
              <v-icon v-if="item.pivot.paymentMethod == 'CC'">mdi-credit-card-refund</v-icon>
              <v-icon v-else>mdi-cash-refund</v-icon>
            </v-btn>

          </v-avatar>
        </v-list-item-avatar>
        <v-list-item-avatar v-else-if="item.pivot.paymentStatus != 'paid'">
          <v-avatar tile v-if="checkGate('void-transaction')">

            <v-btn class="green--text" @click="undoVoidItem(item)"
              v-if="item.category != 'split' && item.category != 'pckg'" icon>
              <v-icon v-if="item.pivot.paymentMethod == 'CC'">mdi-credit-card-plus</v-icon>
              <v-icon v-else>mdi-cash-plus</v-icon>
            </v-btn>

            <v-btn class="green--text" @click="undoRefund(item)" v-if="item.category == 'pckg'" icon>
              <v-icon v-if="item.pivot.paymentMethod == 'CC'">mdi-credit-card-plus</v-icon>
              <v-icon v-else>mdi-cash-plus</v-icon>
            </v-btn>

          </v-avatar>
        </v-list-item-avatar>
      </v-list-item>
    </v-list>
  </div>
</template>
<style> /*.purchased.v-list{ padding : 0;  }*/
 .v-data-table__expanded__content .purchased.v-list {
   max-width: 85%;
   margin: auto;
 }

 .voided .v-list-item__content,
 .canceled .v-list-item__content,
 .refunded .v-list-item__content {
   text-decoration: line-through;
 }

 .pending .v-list-item__content {
   font-style: italic
 }

 .deleted {
   display: none
 }

 .credit {
   display: inline;
 }

 /* */
 .purchased .v-list-item__content>* {
   flex: none
 }
</style>
}


<script>

export default {
  props: ['items', 'customer_id', 'status'],

  methods: {

    refund(item) {

      const index = this.items.indexOf(item)

      item.pivot.paymentStatus = 'refunded'

      // confirm('Are you sure you want to cancel this item?') && 
      axios.put('/api/customers/refundJump/' + this.customer_id, { item: item })
        .then(response => {


          this.$store.dispatch('fetchData')
          //this.$store.dispatch('fetchCustomersWithAddons')

        }).catch(err => {

          this.errorMessage = err
          this.errorText = err.response.request.response
          this.errorURL = err.response.request.responseURL
        })
    },

    undoRefund(item) {

      const index = this.items.indexOf(item)

      item.pivot.paymentStatus = 'paid'

      // confirm('Are you sure you want to cancel this item?') && 
      axios.put('/api/customers/undoRefundJump/' + this.customer_id, { item: item })
        .then(response => {

          this.$store.dispatch('fetchData')
          //this.$store.dispatch('fetchCustomersWithAddons')

        }).catch(err => {

          this.errorMessage = err
          this.errorText = err.response.request.response
          this.errorURL = err.response.request.responseURL
        })

    },

    voidItem(item) {

      const index = this.items.indexOf(item)

      // confirm('Are you sure you want to cancel this item?') && 
      axios.put('/api/customers/void/' + this.customer_id, { item: item })
        .then(response => {

          item.pivot.paymentStatus = 'refunded'

        })
        .catch(err => {
          this.errorMessage = err
          this.errorText = err.response.request.response
          this.errorURL = err.response.request.responseURL
        })

    },

    undoVoidItem(item) {
      const index = this.items.indexOf(item)

      axios.put('/api/customers/undoVoid/' + this.customer_id, { item: item })
        .then(response => {

          item.pivot.paymentStatus = 'paid'

        })
        .catch(err => {
          this.errorMessage = err
          this.errorText = err.response.request.response
          this.errorURL = err.response.request.responseURL
        })
    },

    deleteItem(item) {

      const index = this.items.indexOf(item)
      item.paymentStatus = 'deleted'


      axios.put('/api/customers/void/' + this.customer_id, { item: item })
        .then(response => {


          this.items.splice(index, 1)
          this.$emit('removefromBasket', item)

        })
        .catch(err => {
          this.errorMessage = err
          this.errorText = err.response.request.response
          this.errorURL = err.response.request.responseURL
        })

    },

    removefromBasket(item) {
      this.$emit('removefromBasket', item)
    },

    isPast(transactionDate) {

      var today = new Date().yyyymmdd()
      today = new Date(today + "T00:00:00")

      transactionDate = new Date(transactionDate).yyyymmdd()
      transactionDate = new Date(transactionDate + "T00:00:00")

      return transactionDate.getTime() < today.getTime()

    },
  }
}
</script>